<template>
  <div id="app">
    <loading :active.sync="isLoading"></loading>
    <vue-page-transition>
      <router-view/>
    </vue-page-transition>
    <notifications position="top left"/>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.min.css'

export default {
  name: 'TheContainer',
  async mounted () {
    await this.loadSystemSettings()
    await this.applyStyleCss()
    this.$bus.$on('display-alert', obj => {
      const {type, message} = obj
      this.$notify({type, text: message})
    })
    this.verifyNewCurrent()
  },
  data () {
    return {
      isLoading: false,
      keepLoading: false
    }
  },
  components: {
    Loading
  },
  created: function () {
    this.$bus.$on('set-keep-loading', this.keepLoadingOn)
    this.$bus.$on('unset-keep-loading', this.keepLoadingOff)
    this.$bus.$on('before-request', this.showSpinner)
    this.$bus.$on('request-error', this.hideSpinner)
    this.$bus.$on('after-response', this.hideSpinner)
    this.$bus.$on('response-error', this.hideSpinner)
    this.$bus.$on('apply-color-css', this.applyStyleCss)
  },
  beforeDestroy: function () {
    this.$bus.$off('set-keep-loading', this.keepLoadingOn)
    this.$bus.$off('unset-keep-loading', this.keepLoadingOff)
    this.$bus.$off('before-request', this.showSpinner)
    this.$bus.$off('request-error', this.hideSpinner)
    this.$bus.$off('after-response', this.hideSpinner)
    this.$bus.$off('response-error', this.hideSpinner)
    this.$bus.$off('apply-color-css')
  },
  methods: {
    ...mapActions('permissions', ['fetch']),
    ...mapActions('switchUsers', ['getNewCurrent']),
    ...mapActions('settings', ['loadSystemSettings']),
    keepLoadingOn () {
      this.keepLoading = true
    },
    keepLoadingOff () {
      this.keepLoading = false
      this.isLoading = false
    },
    showSpinner () {
      this.isLoading = true
    },
    hideSpinner () {
      if (!this.keepLoading) {
        this.isLoading = false
      }
    },
    verifyNewCurrent () {
      this.getNewCurrent()
    },
    async applyStyleCss () {
      if (this.notHaveColors) {
        await this.loadSystemSettings()
      }
      const settings = this.systemSettings
      const css = [
        // PRIMARY-COLOR
        `.skin-background-1 { background-color: ${settings.primary_color} !important; }`, // CLASSE PARA FUNDOS COR PRIMARIA
        `.skin-border-1 { border: 1px solid ${settings.primary_color} !important; }`, // CLASSE PARA BORDAR COR PRIMARIA
        `.skin-background-1-hover:hover:not(.link-active-exact) { background-color: ${settings.primary_color} !important; color: white !important; }`, // CLASSE PARA FUNDOS HOVER COR PRIMARIA
        `.skin-title-1 { color: ${settings.primary_color} !important }`, // CLASSE PARA TITULOS COR PRIMARIA
        `.skin-dropdown-1-focus:focus { background-color: ${settings.primary_color} !important; color: white; }`, // CLASSE PARA FUNDOS FOCUS COR PRIMARIA
        `.link-active-exact, .link-active-exact a { color: white; background-color: ${settings.primary_color} !important; opacity: 0.88 !important }`, // Alterando cor de menu selecionado para levar em conta as cores do sistema
        `.skin-background-1-active:active { background-color: ${settings.primary_color} !important; color: white; }`, // CLASSE PARA FUNDOS ACTIVE COR PRIMARIA

        // SECUNDARY-COLOR
        `.skin-background-2 { background-color: ${settings.secundary_color} !important; }`, // CLASSE PARA FUNDOS COR SECUNDARIA
        `.skin-dropdown-2-focus:focus { background-color: ${settings.secundary_color} !important; color: white; }`, // CLASSE PARA FUNDOS ACTIVE COR SECUNDARIA
        `.skin-background-2-active:active { background-color: ${settings.secundary_color} !important; color: white; }`, // CLASSE PARA FUNDOS FOCUS COR SECUNDARIA
        `.skin-border-2 { border: 1px solid ${settings.secundary_color} !important; }`, // CLASSE PARA BORDAR COR SECUNDARIA
        `div .v-step { background-color: ${settings.secundary_color} !important; }`, // Alterando cor do fundo da DIV do tour
        `.v-step .v-step__arrow[data-v-570be51d] { border-color: ${settings.secundary_color} !important; }`, // Alterando cor da seta da DIV do tour
        `.skin-background-2-hover:hover:not(.link-active-exact) { background-color: ${settings.secundary_color} !important; color: ${settings.menu_text_color}; }`, // CLASSE PARA FUNDOS HOVER COR SECUNDARIA

        // THIRD-COLOR
        `.skin-title-2 { color: ${settings.third_color} }`,

        // MENU-TEXT-COLOR
        `.skin-menu-color-1 a { color: ${settings.menu_text_color} }`, // CLASSE PARA COR DA FONTE NO MENU
        `.text-logout, .icon-header-custom { color: ${settings.menu_text_color} !important; }`, // CLASSE PARA COR NOS ICONES DO HEADER
        `.skin-subtitle { color: ${settings.subtitle_text_color} !important  }` // CLASSE PARA COR DOS SUBTITULOS
      ]
      const style = document.createElement('style')
      css.forEach(element => {
        style.appendChild(document.createTextNode(element))
      })

      /* ADICIONANDO OUTRAS CONFIG */
      document.title = settings.title
      let linkFavicon = document.querySelector('link[rel*=\'icon\']')
      linkFavicon.href = settings.favicon_url

      document.getElementsByTagName('head')[0].appendChild(style)
      document.getElementsByTagName('head')[0].appendChild(linkFavicon)
    }
  },
  computed: {
    ...mapState('settings', {
      systemSettings (state) {
        return state.systemSettings
      },
      notHaveColors (state) {
        return (state.systemSettings.primary_color === '' && state.systemSettings.secundary_color === '')
      }
    })
  }
}
</script>

<style lang="scss" src="@/assets/scss/app.scss"></style>



// WEBPACK FOOTER //
// src/the-container.vue